<ol class="breadcrumb">
    <breadcrumbs></breadcrumbs>
</ol>
<div class="container-fluid">
    <div class="row">
        <div class="col-sm-6">
            <div class="card">
                <div class="card-header">
                    <strong>ユーザ一覧</strong>
                </div>
                <div class="card-body">
                    <div class="row">
                        <div class="col-md-3">
                            <wj-menu [(value)]="readonly" [isDisabled]="users.hasChanges()" [header]="'編集モード'">
                                <wj-menu-item [value]="true">ロック</wj-menu-item>
                                <wj-menu-item [value]="false">編集可能</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div class="col-md-3"><span>該当　{{users.totalCount|number}}　件</span></div>
                        <div class="col-md-6">
                            <button (click)="createUser()" class="btn btn-primary btn-block">新規ユーザ作成</button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-sm-12">
                            <wj-flex-grid #grid [isReadOnly]="readonly" style="height:500px" [itemsSource]="users">
                                <wj-flex-grid-filter></wj-flex-grid-filter>
                                <wj-flex-grid-column [header]="'名前'" [binding]="'name'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'ステータス'" [binding]="'status'" [width]="150"></wj-flex-grid-column>
                                <wj-flex-grid-column [header]="'役割'" [binding]="'roles'" [width]="300">
                                    <ng-template wjFlexGridCellTemplate [cellType]="'Cell'" let-cell="cell">
                                        <span *ngFor='let role of cell.item.roles'> {{role.name}} </span>
                                    </ng-template>
                                </wj-flex-grid-column>
                            </wj-flex-grid>
                        </div>
                    </div>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div style="float:left; min-width: 150px;">
                            <wj-menu [(value)]="users.pageSize" [header]="'ページサイズ'">
                                <wj-menu-item [value]="100">100</wj-menu-item>
                                <wj-menu-item [value]="500">500</wj-menu-item>
                                <wj-menu-item [value]="1000">1000</wj-menu-item>
                            </wj-menu>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-navigator [cv]="users"></wj-collection-view-navigator>
                        </div>
                        <div style="float:left; min-width: 150px;">
                            <wj-collection-view-pager [cv]="users"></wj-collection-view-pager>
                        </div>
                    </div>
                    <div class="row">
                        <button *ngIf="!readonly" [disabled]="!users.hasChanges()" (click)="users.saveChanges()" class="btn btn-primary btn-block">変更保存</button>
                        <button *ngIf="!readonly" [disabled]="!users.hasChanges()" (click)="users.cancelChanges()" class="btn btn-primary btn-block">キャンセル</button>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-sm-6">
            <div class="card" *ngIf="user['@rid'] == '#-1:-1'">
                <div class="card-header">
                    <strong>ユーザ作成</strong>
                </div>
                <div class="card-body">
                    <form class="form-horizontal" [formGroup]="createForm">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">ユーザ名</label>
                            <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(createForm,username,'username')}" tooltip="ユーザ名は３文字以上である必要があります。" triggers="" #username="bs-tooltip" placement="top">
                                <input *ngIf="mode == 'edit'" type="text" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(createForm, 'username')}" formControlName="username" [(ngModel)]="user.name" placeholder="ユーザ名">
                                <span *ngIf="mode != 'edit'">{{user.name}}</span>
                            </div>
                        </div>
                        <div formGroupName="password">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">パスワード</label>
                                <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(createForm,newPassword,'password','newPassword')}" tooltip="パスワードは６文字以上である必要があります。" triggers="" #newPassword="bs-tooltip" placement="top">
                                    <input *ngIf="mode == 'edit'" type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(createForm, 'password','newPassword')}" formControlName="newPassword" [(ngModel)]="user.password" placeholder="パスワード">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">パスワード再入力</label>
                                <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(createForm,confirmPassword,'password')}" tooltip="パスワードとパスワード再入力が一致しません。" triggers="" #confirmPassword="bs-tooltip" placement="top">
                                    <input *ngIf="mode == 'edit'" type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(createForm, 'password')}" formControlName="confirmPassword" placeholder="パスワード再入力">
                                </div>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">ステータス</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status" [ngModelOptions]="{standalone: true}" placeholder="ステータス">
                                    <option value="ACTIVE">有効</option>
                                    <option value="SUSPENDED">無効</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!createForm.valid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> 確認</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'edit'">
                            <button type="button" class="btn btn-block btn-danger" (click)="createUser()"><i class="fa fa-ban"></i> リセット</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> 保存</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> 戻る</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="user['@rid'] != '#-1:-1'">
                <div class="card-header">
                    <strong *ngIf="mode == 'edit'">ユーザ編集</strong>
                    <strong *ngIf="mode != 'edit'">ユーザ</strong>
                </div>
                <div class="card-body">
                    <form class="form-horizontal" [formGroup]="editForm">
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">ユーザ名</label>
                            <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(editForm,username,'username')}" tooltip="ユーザ名は３文字以上である必要があります。" triggers="" #username="bs-tooltip" placement="top">
                                <input *ngIf="mode == 'edit'" type="text" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(editForm, 'username')}" formControlName="username" [(ngModel)]="user.name" placeholder="ユーザ名">
                                <span *ngIf="mode != 'edit'">{{user.name}}</span>
                            </div>
                        </div>
                        <div class="form-group row">
                            <label class="col-md-3 form-control-label">ステータス</label>
                            <div class="col-md-9">
                                <select [disabled]="mode != 'edit'" class="form-control" [(ngModel)]="user.status" [ngModelOptions]="{standalone: true}" placeholder="ステータス">
                                    <option value="ACTIVE">有効</option>
                                    <option value="SUSPENDED">無効</option>
                                </select>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-footer">
                    <div class="row">
                        <div class="col-sm-12" *ngIf="mode == 'edit'">
                            <button type="button" [disabled]="!editForm.valid" class="btn btn-block btn-primary" (click)="confirmUser()"><i class="fa fa-dot-circle-o"></i> 確認</button>
                        </div>
                        <div class="col-sm-12" *ngIf="mode == 'view'">
                            <button type="button" class="btn btn-block btn-primary" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> 編集</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-success" (click)="saveUser()"><i class="fa fa-dot-circle-o"></i> 保存</button>
                        </div>
                        <div class="col-sm-6" *ngIf="mode == 'confirm'">
                            <button type="button" class="btn btn-block btn-default" (click)="editUser()"><i class="fa fa-dot-circle-o"></i> 戻る</button>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card" *ngIf="user['@rid'] != '#-1:-1' && mode == 'edit'">
                <div class="card-header">
                    <strong>パスワード</strong>
                </div>
                <div class="card-body">
                    <form class="form-horizontal" [formGroup]="passwordForm">
                        <div formGroupName="password">
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">パスワード</label>
                                <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(passwordForm,newPassword,'password','newPassword')}" tooltip="パスワードは６文字以上である必要があります。" triggers="" #newPassword="bs-tooltip" placement="top">
                                    <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(passwordForm, 'password','newPassword')}" formControlName="newPassword" [(ngModel)]="password" placeholder="パスワード">
                                </div>
                            </div>
                            <div class="form-group row">
                                <label class="col-md-3 form-control-label">パスワード再入力</label>
                                <div class="col-md-9" [ngClass]="{'has-danger':formHelper.hasErrorTooltip(passwordForm,confirmPassword,'password')}" tooltip="パスワードとパスワード再入力が一致しません。" triggers="" #confirmPassword="bs-tooltip" placement="top">
                                    <input type="password" class="form-control" [ngClass]="{'form-control-danger':formHelper.hasError(passwordForm, 'password')}" formControlName="confirmPassword" placeholder="パスワード再入力">
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card-footer">
                    <div class="col-sm-12">
                        <button type="button" [disabled]="!passwordForm.valid" class="btn btn-block btn-primary" (click)="changePassword()"><i class="fa fa-dot-circle-o"></i> 変更</button>
                    </div>
                </div>
            </div>

        </div>
    </div>
</div>
